import { Tween, Easing } from "@tweenjs/tween.js";
import * as THREE from "three";

export const changeIntensity = (light, intensity, options) => {
  const { duration, delay, easing } = options || {};

  new Tween(light)
    .to({ intensity }, duration || 1000)
    .easing(easing || Easing.Quadratic.InOut)
    .delay(delay || 0)
    .start();
};

export const changeColor = (light, color, options) => {
  const { duration, delay, easing } = options || {};
  const newColor = new THREE.Color(color);

  new Tween(light)
    .to({ color: newColor }, duration || 1000)
    .easing(easing || Easing.Quadratic.InOut)
    .delay(delay || 0)
    .start();
};
